import { OnInit } from '@angular/core';
import { Globals } from '../objects/Globals';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../services/login.service';
import { TokenManager } from '../Globals';
import { SummaryService } from '../services/summary.service';
var LayoutDefaultComponent = /** @class */ (function () {
    function LayoutDefaultComponent(route, globals, router, loginService, tokenManager, summaryService) {
        this.route = route;
        this.globals = globals;
        this.router = router;
        this.loginService = loginService;
        this.tokenManager = tokenManager;
        this.summaryService = summaryService;
        this.searchKeyword = '';
        this.smallPad = false;
        this.refreshView = false;
        this.isShowBar = true;
        this.smallSum = false;
    }
    LayoutDefaultComponent.prototype.onResize = function (event) {
        if (event.target.innerWidth < 992) {
            this.smallPad = true;
            this.fullDetail = true;
            if (this.smallSum) {
                this.onMobile = true;
            }
        }
        else {
            this.onMobile = false;
            this.fullDetail = false;
            if (this.isShowBar) {
                this.smallPad = false;
            }
        }
    };
    LayoutDefaultComponent.prototype.onSelectedItem = function (selectedId) {
        this.selectedDetailId = selectedId;
        this.onMobile = window.innerWidth < 992;
        this.smallSum = true;
    };
    LayoutDefaultComponent.prototype.onSelectedType = function (selectedType) {
        this.selectedDetailType = selectedType;
        this.selectedSubDetailId = null;
        this.selectedSubDetailType = null;
    };
    LayoutDefaultComponent.prototype.onSelectedSubItemId = function (selectedId) {
        this.selectedSubDetailId = selectedId;
    };
    LayoutDefaultComponent.prototype.onSelectedSubItemType = function (selectedType) {
        this.selectedSubDetailType = selectedType;
    };
    LayoutDefaultComponent.prototype.onSearchKeywordChange = function (keyword) {
        this.searchKeyword = keyword;
    };
    LayoutDefaultComponent.prototype.onViewChange = function (summaryId) {
        this.componentId = summaryId;
    };
    LayoutDefaultComponent.prototype.toggleSidebar = function (showView) {
        this.isShowBar = showView;
        if (showView) {
            this.smallPad = false;
        }
        else {
            this.smallPad = true;
        }
    };
    LayoutDefaultComponent.prototype.setSummaryName = function ($event) {
        this.summaryName = $event;
    };
    LayoutDefaultComponent.prototype.forceRefreshView = function () {
        this.refreshView = !this.refreshView;
    };
    LayoutDefaultComponent.prototype.toggleSummary = function () {
        this.smallPad = !this.smallPad;
    };
    LayoutDefaultComponent.prototype.switchSummary = function () {
        this.onMobile = false;
    };
    LayoutDefaultComponent.prototype.ngOnInit = function () {
        this.smallPad = (window.innerWidth) < 992;
        this.fullDetail = window.innerWidth < 992;
        var self = this;
        this.tokenManager.store("BRNCurrentRoute", this.router.url);
        if (this.globals.Session == null) {
            self.router.navigate(['/', '/']);
        }
        else {
            this.session = this.globals.Session.Session;
        }
        this.componentId = this.route.snapshot.paramMap.get('summaryId');
        if (this.route.snapshot.paramMap.get('detailComponentId')) {
            this.selectedDetailId = this.route.snapshot.paramMap.get('detailComponentId');
        }
        // if(this.componentId && this.session){
        //   this.summaryService.getCurrentSearchKeyword(this.componentId).subscribe(result=>{
        //     if(result){
        //       this.searchKeyword = result;
        //     }else{
        //       this.searchKeyword = "";
        //     }
        //   })
        // }
    };
    return LayoutDefaultComponent;
}());
export { LayoutDefaultComponent };
